import React from 'react';

import { FrequencyCategory } from './FrequencyCategory';
import { WeightCategory } from './WeightCategory';
import { CargoHandlingCategory } from './CargoHandlingCategory';
import { PostureCategory } from './PostureCategory';
import { WorkConditionCategory } from './WorkConditionCategory';
import { WorkOrganizationCategory } from './WorkOrganizationCategory';

import type { KimLhcCategories } from '@/types';
import { KimLhcCategoryKey } from '@/types';

interface CategoryRendererProps {
	category: KimLhcCategoryKey;
	categories: KimLhcCategories;
}

export function CategoryRenderer({ category, categories }: Readonly<CategoryRendererProps>): JSX.Element {
	const categoryMap: Record<KimLhcCategoryKey, JSX.Element> = {
		[KimLhcCategoryKey.FREQUENCY]: <FrequencyCategory data={categories.frequency} />,
		[KimLhcCategoryKey.WEIGHT]: <WeightCategory data={categories.weight} />,
		[KimLhcCategoryKey.CARGO_HANDLING_CONDITION]: <CargoHandlingCategory data={categories.cargoHandlingCondition} />,
		[KimLhcCategoryKey.POSTURE]: <PostureCategory data={categories.posture} />,
		[KimLhcCategoryKey.WORK_CONDITION]: <WorkConditionCategory data={categories.workCondition} />,
		[KimLhcCategoryKey.WORK_ORGANIZATION]: <WorkOrganizationCategory data={categories.workOrganization} />
	};

	return categoryMap[category];
}
